<template>
  <div>
    <b-alert
      :show="infoMessage.length > 0"
      variant="info"
      dismissible
    >
      {{ infoMessage }}
    </b-alert>
    <b-alert
      :show="warningMessage.length > 0"
      variant="warning"
      dismissible
    >
      {{ warningMessage }}
    </b-alert>
    <b-alert
      :show="dangerMessage.length > 0"
      variant="danger"
      dismissible
    >
      {{ dangerMessage }}
    </b-alert>
    <b-alert
      :show="successMessage.length > 0"
      variant="success"
      dismissible
    >
      {{ successMessage }}
    </b-alert>
  </div>
</template>

<script>
export default {
  name: "Alert",
  computed: {
    infoMessage: function() {
      return this.$store.state.alert.info;
    },
    warningMessage: function() {
      return this.$store.state.alert.warning;
    },
    dangerMessage: function() {
      return this.$store.state.alert.danger;
    },
    successMessage: function() {
      return this.$store.state.alert.success;
    }
  }
};
</script>